import { Map } from 'immutable'

export const isUserOnPageExist = (state: Map<string, any>, userId: number): boolean => {
  return !!state.getIn(['users', 'usersOnPage', userId.toString(), 'email'])
}
